import React from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const PageHeader = ({ title, trailing }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(-1);
  };
  return (
    <div className="d-flex align-items-center">
      <button className="d-flex align-items-center m-2" style={{ backgroundColor: "#eeeeee", height: 30, width: 30, borderRadius: 100 }} onClick={handleClick}>
        <IoIosArrowBack color="#000" />
      </button>
      <h4 className="m-2 pagehead">{title}</h4>
      {trailing && <div className="m-3 trailing__item">{trailing}</div>}
    </div>
  );
};

export default PageHeader;
